import React from 'react';

import { ParseArticleBody } from '~/src/templates/content/common';

import { Container, Title, Text } from './elements';

interface Props {
  content: {
    title: string;
    parsed_body: string;
  };
}

export const Description: React.FC<Props> = ({ content }) => {
  const { title, parsed_body } = content;

  return (
    <Container>
      <Title>{title}</Title>
      <Text>
        <ParseArticleBody parsed_body={parsed_body} />
      </Text>
    </Container>
  );
};
